import type { PartnerResponseDto } from "Infrastructure/Api/Api";
import { PartnerAddressInfoWidget } from "Partner/Widgets/Info/PartnerAddressInfoWidget";
import { PartnerBankAccountInfoWidget } from "Partner/Widgets/Info/PartnerBankAccountInfoWidget";
import { PartnerBillingProfileInfoWidget } from "Partner/Widgets/Info/PartnerBillingProfileInfoWidget";
import { PartnerGeneralInfoWidget } from "Partner/Widgets/Info/PartnerGeneralInfoWidget";
import { PartnerScoreInfoWidget } from "Partner/Widgets/Info/PartnerScoreInfoWidget";
import { PartnerAllocationHistoryWidget } from "Partner/Widgets/PartnerAllocationHistoryWidget";
import { PRIMARY_ADDRESS } from "Shared/consts";
import { Grid2 } from "@mui/material";

type PartnerDetailTabProps = {
	partner: PartnerResponseDto;
};

export function PartnerDetailTab({ partner }: PartnerDetailTabProps) {
	const primaryAddress = partner.address?.find(
		(item) => item.type === PRIMARY_ADDRESS,
	);

	return (
		<Grid2 container spacing={2}>
			<Grid2 size={{ xs: 12 }}>
				<PartnerGeneralInfoWidget
					generalInfo={partner.partner}
					verticals={partner.verticals}
				/>
			</Grid2>

			<Grid2 size={{ xs: 12 }}>
				<PartnerScoreInfoWidget partnerId={partner.partner.id} />
			</Grid2>

			{primaryAddress && (
				<Grid2 size={{ xs: 12, md: 6 }} key={primaryAddress.id}>
					<PartnerAddressInfoWidget address={primaryAddress} />
				</Grid2>
			)}

			{partner.billingProfile?.map((billingProfile, index) => (
				<Grid2 size={{ xs: 12, md: 6 }} key={billingProfile.id}>
					<PartnerBillingProfileInfoWidget
						key={billingProfile.id}
						billingProfile={billingProfile}
						index={index}
					/>
				</Grid2>
			))}

			{partner.bankAccount?.map((bankAccount, index) => (
				<Grid2 size={{ xs: 12, md: 6 }} key={bankAccount.id}>
					<PartnerBankAccountInfoWidget
						bankAccount={bankAccount}
						index={index}
					/>
				</Grid2>
			))}

			<Grid2 size={{ xs: 12 }}>
				<PartnerAllocationHistoryWidget partnerId={partner.partner.id} />
			</Grid2>
		</Grid2>
	);
}
